import {EventEmitter} from '@angular/core';
import {UploadStore}  from '../../stores/import/upload.store';

export class FileStreamer {
  private offset = 0;
  private readonly defaultChunkSize = 512 * 1024; // bytes
  public onChunkFinish = new EventEmitter<any>();
  public onFinish = new EventEmitter<any>();
  public onError = new EventEmitter<any>();

  constructor(private file: File,
              private uploadStore: UploadStore,
              private uid: string) {
    this.rewind();

    this.uploadStore.Listen(s => s.guid).subscribe(guid => {
      if (guid == null) {
        return;
      }
      if (guid === this.uid) {
        if (!this.isEndOfFile()) {
          this.onChunkFinish.emit(this.offset);
          this.readBlockAsText();
        } else {
          this.onFinish.emit(this.offset);
        }
      }
    });
  }

  public rewind(): void {
    this.offset = 0;
  }

  public isEndOfFile(): boolean {
    return this.offset >= this.getFileSize();
  }

  public readBlockAsText(length: number = this.defaultChunkSize): void {
    const fileReader = new FileReader();
    const blob: Blob = this.file.slice(this.offset, this.offset + length);

    fileReader.onloadend = (event: ProgressEvent) => {
      const target = (event.target) as FileReader;
      if (target.error == null) {
        const result: ArrayBuffer = target.result as ArrayBuffer;
        this.offset += result.byteLength;

        this.uploadStore.sendUpload(this.uid, result);
      } else {
        this.onError.emit(target.error);
      }
    };
    fileReader.readAsArrayBuffer(blob);
  }

  private getFileSize(): number {
    return this.file.size;
  }
}
